export default async function injectSprite() {
    try {
        const res = await fetch("/images/countries/flags-sprite.svg");
        if (!res.ok) {
            console.error("Cannot load sprite:", res.status, res.statusText);
            return;
        }
        const spriteText = await res.text();
        const wrapper = document.createElement("div");
        wrapper.innerHTML = spriteText.trim();
        const spriteSVG = wrapper.querySelector("svg");

        if (!spriteSVG) {
            console.error("Sprite has no <svg>");
            return;
        }

        spriteSVG.setAttribute(
            "style",
            "position:absolute; width:0; height:0; overflow:hidden;",
        );

        document.body.prepend(spriteSVG);
    } catch (error) {
        console.error("Error injecting sprite:", error);
    }
}
